/*=========================================================================================
  File Name: ticketState.js
  Description: Ticket State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Daniyal
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    departments: [],
    tickets: [],
    selectedTicket: {},
    lastPage: 1
};